document.addEventListener("keydown", function (e) {
  if (e.key !== "Enter") return;
  if (!e.target || !(e.target instanceof HTMLElement)) return;

  const target = e.target.closest("[data-dfg]");
  if (!target || !(target instanceof HTMLElement) || !target.dataset.dfg) return;

  e.preventDefault();
  target.click();
});

document.addEventListener("click", function (e) {
  if (!e.target || !(e.target instanceof HTMLElement)) return;

  const target = e.target.closest("[data-dfg]");
  if (!target || !(target instanceof HTMLElement) || !target.dataset.dfg) return;

  if (target.hasAttribute("data-cart-drawer-trigger")) {
    if (window.Rebuy?.SmartCart?.status === "ready") {
      window.Rebuy.SmartCart.show();
      return;
    }
    // Rebuy not loaded/ready: let the theme's native cart-drawer.js listener
    // (attached to this same element) open the fallback drawer instead of navigating.
    if (document.querySelector("cart-drawer")) return;
  }

  const url = decodeURIComponent(atob(target.dataset.dfg.split("").reverse().join("")));

  if (target.dataset.b === "1" || e.ctrlKey) {
    const newWindow = window.open(url, "_blank");
    newWindow?.focus();
  } else {
    window.location.href = url;
  }
});